function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable jsx-a11y/interactive-supports-focus, jsx-a11y/role-has-required-aria-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { unescape } from 'lodash';
import { SEARCH_TYPES } from "../../constants";

var SearchResultOption =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchResultOption, _Component);

  function SearchResultOption() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SearchResultOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SearchResultOption)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getHighlightedTitle", function () {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var query = arguments.length > 1 ? arguments[1] : undefined;
      if (!query) return text;
      var lowerText = text.toLowerCase();
      var lowerQuery = query.toLowerCase();
      var parts = lowerText.split(lowerQuery);

      if (parts.length > 1) {
        var lettersCounter = 0;
        var partsLastIndex = parts.length - 1;
        return parts.map(function (part, index) {
          var textNode = React.createElement("span", null, text.slice(lettersCounter, lettersCounter + part.length));
          lettersCounter += part.length;
          var highlightedNode = index !== partsLastIndex ? React.createElement("span", {
            className: "Select-option-highlighted"
          }, text.slice(lettersCounter, lettersCounter + query.length)) : null;
          lettersCounter += query.length;
          return React.createElement("span", {
            key: index
          }, textNode, highlightedNode);
        });
      }

      return text;
    });

    _defineProperty(_assertThisInitialized(_this), "isSearchForTracks", function () {
      return _this.props.searchName === SEARCH_TYPES.TRACKS;
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      _this.props.onSelect(_this.props.option, e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseMove", function (e) {
      _this.props.onFocus(_this.props.option, e);
    });

    _defineProperty(_assertThisInitialized(_this), "renderImage", function (imageUrl) {
      return _this.isSearchForTracks() ? React.createElement("div", {
        className: "SearchResultsItem-image"
      }, imageUrl ? React.createElement("img", {
        className: "TrackAlbumArt",
        role: "presentation",
        src: imageUrl
      }) : React.createElement("div", {
        className: "SearchResultsItem-image-placeholder"
      })) : '';
    });

    _defineProperty(_assertThisInitialized(_this), "renderReleaseName", function () {
      var releaseName = _this.props.releaseName;
      return releaseName === undefined ? '' : React.createElement("span", null, ' ', "\xB7", releaseName);
    });

    return _this;
  }

  _createClass(SearchResultOption, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          option = _this$props.option,
          className = _this$props.className,
          artistName = _this$props.artistName,
          imageUrl = _this$props.imageUrl,
          isrc = _this$props.isrc,
          query = _this$props.query;
      return React.createElement("div", {
        className: className,
        role: "option",
        onClick: this.handleClick,
        onMouseMove: this.handleMouseMove
      }, this.renderImage(imageUrl), React.createElement("div", {
        className: "SearchResultsItem-isrc"
      }, this.getHighlightedTitle(isrc, query)), React.createElement("div", {
        className: "SearchResultsItem-trackTitle"
      }, this.getHighlightedTitle(option.trackName, query)), React.createElement("div", {
        className: "SearchResultsItem-artist"
      }, this.getHighlightedTitle(unescape(artistName), query), ' ', this.renderReleaseName()));
    }
  }]);

  return SearchResultOption;
}(Component);

_defineProperty(SearchResultOption, "propTypes", {
  option: PropTypes.shape({
    upc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    trackName: PropTypes.string
  }).isRequired,
  isrc: PropTypes.string,
  imageUrl: PropTypes.string,
  artistName: PropTypes.string,
  releaseName: PropTypes.string,
  query: PropTypes.string,
  className: PropTypes.string,
  onSelect: PropTypes.func,
  onFocus: PropTypes.func,
  searchName: PropTypes.string
});

export default SearchResultOption;